<template>
  <!--Begin right info-->
  <div class="info_detal_r panel_bg">
    <div class="side_sticky">
      <div class="hotel_info">
        <div class="div_hotel_info_img">
          <img
            alt="hotel image"
            class="hotel_info_img"
            :src="OrderData.hotelInfo.cover ? OrderData.hotelInfo.cover : defaultImg"
            :onerror="defaultImg"
            style="width: 100%; height: 100%; object-fit: cover; object-position: center;"
          />
        </div>
        <div class="hotel_info_text">
          <ul>
            <li>
              <h1>{{ showHotelName(OrderData.hotelInfo.name)}}</h1>
            </li>
            <li style="display: flex; align-items: center;">
              <template v-if="OrderData.hotelInfo.standardStar > 0">
                <el-rate v-model="OrderData.hotelInfo.standardStar" disabled class="my-rate-reform" :colors="['#F2A900', '#F2A900', '#F2A900']"></el-rate>
              </template>
              <template v-else>
                <span v-for="n in OrderData.hotelInfo.starRating" :key="n">
                  <svg-icon icon-class="hotel_icon_diamond" style="height: 13px;width:18px;padding-right:0"></svg-icon>
                </span>
              </template>
              <span v-if="OrderData.orderInfo.emission && OrderData.orderInfo.emission.score >= 45">
                <span style="margin-right: -.7rem;color: #E7E9EA;">{{ separator}}</span>
                <svg-icon icon-class="emission" style="height: 1.7rem;vertical-align: -0.4em;padding-right: 0;"></svg-icon>
                <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
              </span>
            </li>
            <li v-if="this.$objBaseInfo.sourceType == 'CRM'">FXId: {{ OrderData.hotelInfo.id }}</li>
            <li>
              <svg-icon icon-class="phone"></svg-icon>
              <span style="color: #838A90;font-family: 'Source Sans Pro';">{{ OrderData.hotelInfo == undefined ? "" : OrderData.hotelInfo.contactNumber}}</span>
            </li>
            <li>
              <span style="display: flex">
                <span><svg-icon icon-class="location" style="float: left"></svg-icon></span>
                <span style="color: #838A90;font-family: 'Source Sans Pro';">{{ showHotelAddress(OrderData.hotelInfo.address)}}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="panel_dividing_line"></div>
      <div class="div_guest_order_info">
        <div class="div_room_title">{{ $t("CONFIRMATION.ROOMINFO") }}
          <el-button v-if="(OrderData.orderInfo.bookingStatus == 'BOOKED' || OrderData.orderInfo.bookingStatus == 'CHECKOUT') && $objBaseInfo.sourceType == 'CRM'" class="s_btn" 
            style="height:2.7rem;padding:0rem 1rem;float:right" @click="changeApprovedData">{{$t("CONFIRMATION.Edit")}}</el-button>
        </div>
        <div class="div_room_item room_item_margin"><div class="o_title">{{ $t("CONFIRMATION.GUESTNUM") }}</div>
        <div class="o_info">{{ OrderData.orderInfo.roomCount }}</div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.BEDTYPE1") }}</div>
        <div class="o_info">{{ showRoomName }}</div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.BREAKFAST") }}</div> 
        <div v-show="!OrderData.isUpdateBreakfastQty" class="o_info">{{ showBreakfast }}</div>
        <el-select v-model="OrderData.breakfastData" v-if="OrderData.isUpdateBreakfastQty" style="width: 25%;" size="default" @change="updateServiceChargeAndBreakfastQty(1)">
          <el-option v-for="item in breakfastInfo" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.ROOMSIZE") }}</div>
        <div class="o_info">{{ OrderData.roomInfo.area}}<span>m<sup style="font-size: 0.7rem">2</sup></span></div>
      </div>
    </div>
    <div class="panel_dividing_line"></div>
    <div class="div_guest_order_info">
      <div class="div_room_title">{{ $t("CONFIRMATION.ORDERINFO") }}</div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.ORDERNUM") }}</div>
        <div class="o_info">{{ OrderData.orderInfo.bookingId }}</div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.ORDERSTATUS") }}</div>
        <div class="o_info">{{OrderData.orderInfo.bookingStatus? $t("COMMONPARAM.ORDERSTATE." + OrderData.orderInfo.bookingStatus): ""}}</div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.BOOKINGDATE") }}</div>
        <div class="o_info">{{ OrderData.orderInfo.creationDate }}</div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.HOTELTYPE") }}</div>
        <div class="o_info" v-if="OrderData.orderInfo.isCPHotel">{{ $t("CONFIRMATION.NEGOTIATEDHOTELTRUECP") }}</div>
        <div class="o_info" v-else-if="OrderData.orderInfo.isAPHotel">{{ $t("CONFIRMATION.NEGOTIATEDHOTELTRUEAP") }}</div>
        <div class="o_info" v-else>{{ $t("CONFIRMATION.NEGOTIATEDHOTELFALSE") }}</div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.PRICETYPE") }}</div>
        <div class="o_info" v-if="OrderData.orderInfo.priceType.toString() == '0'">{{OrderData.orderInfo.priceOwner == "agreementUser"? $t("DETAIL.CLIENTPRICE")+ OrderData.ChainwidePriceText: $t("DETAIL.CWTPRICE")}}</div>
        <div class="o_info" v-if="OrderData.orderInfo.priceType && OrderData.orderInfo.priceType.toString() != '0' && OrderData.orderInfo.channelDescription!=null">{{OrderData.orderInfo.channelDescription[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]}}</div>
        <div class="o_info" v-if="OrderData.orderInfo.priceType && OrderData.orderInfo.priceType.toString() != '0' && OrderData.orderInfo.channelDescription==null">{{OrderData.orderInfo.priceType? $t("CONFIRMATION.NEGOTIATEDPRICE1"): ""}}</div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.GUARANTEETYPE") }}</div>
        <div class="o_info">{{(OrderData.orderInfo.paymentInfo.isVirtualCard)?$t("CONFIRMATION.VirtualGuarantee"):""}}
          {{(!OrderData.orderInfo.paymentInfo.isVirtualCard && OrderData.orderInfo.guaranteeType)? $t("CONFIRMATION.GUARANTEETYPE" + OrderData.OrderGuaranteeType): ""}}
        </div>
      </div>
      <!-- 酒店确认单号 -->
      <div class="div_room_item room_item_margin" v-if="this.$objBaseInfo.sourceType == 'CRM' &&OrderData.orderInfo.bookingStatus != 'CANCELLED'">
        <div class="o_title">{{ $t("CONFIRMATION.CRMCONFIRMATIONNO") }}</div>
        <div class="o_info">{{ hotelConfirmationNo }}
          <el-button type="primary" v-show="OrderData.isShowSyncHotelConfirmationNo" class="s_btn" @click="UpdatePnrConfirmationNo('hotelConfirmationNo')" style="height:2.7rem;padding:0rem 1rem;">{{ $t("CONFIRMATION.SYNC") }}</el-button>
          <el-button type="primary" v-show="OrderData.isShowUpdateHotelConfirmationNo" class="s_btn" @click="btnClickType('editConfirm')" style="height:2.7rem;padding:0rem 1rem;">{{ $t("CONFIRMATION.Edit") }}</el-button>
        </div>
      </div>
      <!-- 渠道 -->
      <div class="div_room_item room_item_margin" v-if="this.$objBaseInfo.sourceType == 'CRM'">
        <div class="o_title">{{ $t("CONFIRMATION.CRMSOURCE") }}</div>
        <div class="o_info">{{ OrderData.orderInfo.source }}</div>
      </div>
      <!-- PNR -->
      <div class="div_room_item room_item_margin" v-if="this.$objBaseInfo.sourceType == 'CRM'">
        <div class="o_title">{{ $t("CONFIRMATION.CRMPNR") }}</div>
        <div class="o_info">{{ OrderData.orderInfo.sourceBookingId }}
          <el-button type="primary" v-show="OrderData.isShowSyncPnr" class="s_btn" @click="UpdatePnrConfirmationNo('sourceBookingId')" style="height:2.7rem;padding:0rem 1rem;">{{ $t("CONFIRMATION.SYNC") }}</el-button>
        </div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.PAYMENTTYPE") }}</div>
        <div class="o_info">{{ OrderData.orderInfo.paymentInfo?.paymentType ? $t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE" + OrderData.orderInfo.paymentInfo.paymentType) : "" }}</div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.TRAVELPOLICY") }}</div>
        <div class="o_info" v-if="OrderData.orderInfo.isOutOfPolicy != null &&OrderData.orderInfo.isOutOfPolicy != undefined">{{OrderData.orderInfo.isOutOfPolicy? $t("CONFIRMATION.INPOLICYFALSE"): $t("CONFIRMATION.INPOLICYTRUE")}}</div>
      </div>
      <div class="div_room_item room_item_margin">
        <div class="o_title">{{ $t("CONFIRMATION.ISMANUALORDER") }}</div>
        <div class="o_info" v-if="OrderData.orderInfo.isManualOrder != null &&OrderData.orderInfo.isManualOrder != undefined">{{OrderData.orderInfo.isManualOrder? $t("CONFIRMATION.MANUALORDER"): $t("CONFIRMATION.NOTMANUALORDER")}}</div>
      </div>
      <div class="div_room_item room_item_margin" v-if="OrderData.isServicefree">
        <div class="o_title">{{ $t("MANUAL.SERVICEFREE") }}</div>
        <div class="o_info">¥{{ OrderData.orderInfo ? OrderData.serviceFees_original : "" }}</div>
      </div>
      <!-- 紧急服务费 -->
      <div class="div_room_item room_item_margin" v-if="OrderData.isUrgentfee">
        <div class="o_title">{{ $t("CONFIRMATION.EMERGENCY") }}</div>
        <div class="o_info">¥{{OrderData.orderInfo && OrderData.emergencyServiceFee_original? OrderData.emergencyServiceFee_original: "0"}}</div>
      </div>
      <!-- 垫资费 -->
      <div class="div_room_item room_item_margin" v-if="OrderData.orderInfo.paymentInfo && OrderData.orderInfo.paymentInfo.paymentType == '3' && OrderData.isAdvancepayment">
        <div class="o_title">{{ $t("CONFIRMATION.ADVANCEPAYMENT") }}</div>
        <div class="o_info">¥{{ OrderData.orderInfo && OrderData.orderInfo.advancePayment? OrderData.orderInfo.advancePayment: "0" }}</div>
      </div>
      <div class="div_room_item room_item_margin" v-if="this.$objBaseInfo.sourceType == 'CRM' && OrderData.orderInfo.invoiceNumber!=''&& OrderData.orderInfo.invoiceNumber!=undefined">
        <div class="o_title">TAInvoiceNumber</div>
        <div class="o_info">{{ OrderData.orderInfo.invoiceNumber }}</div>
      </div>
      <div v-if="OrderData.orderInfo.paymentInfo.paymentType == 1">
        <div class="div_room_item room_item_margin">
          <div class="total_title">{{ $t("CONFIRMATION.TOTALROOMPRICE") }}</div>
          <div class="total_info">
            <el-tooltip v-if="OrderData.taxesInfo.hasTax" class="item" effect="light" placement="bottom-start"
              :content="(OrderData.taxesInfo.taxAmount? $t('DETAIL.TOTALTAXES') +OrderData.taxesInfo.taxCurrency +OrderData.taxesInfo.taxAmount: '') +' ' +(OrderData.taxesInfo.others? $t('DETAIL.TOTALFEES') +OrderData.taxesInfo.otherCurrency +OrderData.taxesInfo.others: '')">
              <span class="el-icon-info"></span>
            </el-tooltip>
            {{OrderData.orderInfo? ($currencySign[OrderData.orderInfo.currencyCode]? $currencySign[OrderData.orderInfo.currencyCode]: OrderData.orderInfo.currencyCode) + OrderData.orderInfo.totalPrice: ""}}
            <span v-if="OrderData.taxesInfo.hasTax">({{ $t("DETAIL.TAXIN") }})</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="div_room_item room_item_margin" v-if="OrderData.orderInfo.paymentInfo.swipePrice > 0">
          <div class="o_title">{{ $t("CONFIRMATION.CARDSWIPEFEE") }}</div>
          <div class="o_info">¥{{ OrderData.orderInfo.paymentInfo.swipePrice }}</div>
        </div>
        <div class="div_room_item room_item_margin">
          <div class="o_title">{{ $t("CONFIRMATION.TOTALROOMPRICE") }}</div>
          <div class="o_info">
            <el-tooltip v-if="OrderData.taxesInfo.hasTax" class="item" effect="light" placement="bottom-start"
              :content="(OrderData.taxesInfo.taxAmount? $t('DETAIL.TOTALTAXES') +OrderData.taxesInfo.taxCurrency +OrderData.taxesInfo.taxAmount: '') +' ' +(OrderData.taxesInfo.others? $t('DETAIL.TOTALFEES') +OrderData.taxesInfo.otherCurrency +OrderData.taxesInfo.others: '')">
              <span class="el-icon-info"></span>
            </el-tooltip>
            {{OrderData.orderInfo? ($currencySign[OrderData.orderInfo.currencyCode]? $currencySign[OrderData.orderInfo.currencyCode]: OrderData.orderInfo.currencyCode) + OrderData.orderInfo.totalPrice: ""}}
            <span v-if="OrderData.taxesInfo.hasTax">({{ $t("DETAIL.TAXIN") }})</span>
          </div>
        </div>
        <div class="div_room_item room_item_margin">
          <div class="total_title">{{ $t("CONFIRMATION.TOTALPRICE") }}</div>
          <div class="total_info">¥{{ showTotalPrice }}</div>
        </div>
      </div>
      <div class="price_link main_link_tab" @click="showPriceDialog">{{ $t("CONFIRMATION.PRICELINK") }}</div>
      <div class="price_link main_link_tab" @click="showRemarkDialog" v-if="this.$objBaseInfo.sourceType == 'CRM'">{{ $t("CONFIRMATION.REMARKLINK") }}</div>
      <div class="div_room_button room_item_margin">
        <!-- 修改订单 -->
        <button class="s_btn s_btn_small" v-show=" this.$objBaseInfo.sourceType == 'CRM' && !OrderData.isUpdate && OrderData.isShowUpdate" @click="OrderData.isUpdate = true;OrderData.isShowCancel = false;">{{ $t("CONFIRMATION.BTNUPDATE") }}</button>
        <!-- 确认修改 -->
        <button class="s_btn s_btn_small" v-show="this.$objBaseInfo.sourceType == 'CRM' && OrderData.isUpdate" @click="updateOrderInfo">{{ $t("CONFIRMATION.CONFIRMBTNUPDATE") }}</button>
        <!-- 取消修改 -->
        <button class="s_btn s_btn_small" v-show="this.$objBaseInfo.sourceType == 'CRM' && OrderData.isUpdate" @click="cancelUpdate">{{ $t("CONFIRMATION.CANCELBTNUPDATE") }}</button>
        <!-- 取消订单 -->
        <button v-show="OrderData.isShowCancel" class="s_btn s_btn_small" @click="btnClickType('cancle')">{{ $t("CONFIRMATION.BTNCANCEL") }}</button>
        <!-- 强制取消订单 -->
        <button v-show="OrderData.isCompulsionShowCancel" class="s_btn s_btn_small" @click="btnClickType('compulsion')">强制取消</button>
        <!-- 取消CWT单方订单 -->
        <button class="s_btn s_btn_small" v-show="this.$objBaseInfo.sourceType == 'CRM' && OrderData.orderInfo.bookingStatus == 'PENDING_BOOKING'" @click="cancelPendingBookingPost">取消CWT单方订单</button>
        <!-- 修改服务费 -->
        <button class="s_btn s_btn_small" v-show="this.$objBaseInfo.sourceType == 'CRM'" @click="openServiceDialog">修改服务费</button>
        <!-- 确认订单 -->
        <button v-if="this.$objBaseInfo.sourceType == 'CRM' &&OrderData.orderInfo.source == 'CWTbur' &&OrderData.orderInfo.bookingStatus == 'CWT_PENDING_CONFIRMATION'" class="s_btn s_btn_small" @click="btnClickType('confirm')">
          {{ $t("CONFIRMATION.BTNCONFIRM") }}
        </button>
        <!-- 拒绝订单 -->
        <button v-if="this.$objBaseInfo.sourceType == 'CRM' &&OrderData.orderInfo.source == 'CWTbur' &&OrderData.orderInfo.bookingStatus == 'CWT_PENDING_CONFIRMATION'" class="s_btn s_btn_small" @click="btnClickType('reject')">
          {{ $t("CONFIRMATION.BTNREJECT") }}
        </button>
        <!-- elong支付担保订单 source=elong && 现付 && 担保订单 -->
        <button class="s_btn s_btn_small" v-show="OrderData.orderInfo.source == 'elong' &&OrderData.orderInfo.paymentInfo.paymentType == 1 && !OrderData.orderInfo.elongPayFinish &&OrderData.orderInfo.reservationType == 0 &&OrderData.orderInfo.bookingStatus == 'PENDING_CONFIRMATION'" @click="OrderData.elongLink()">
          {{ $t("CONFIRMATION.BTNCONFIRMPAY") }}
        </button>
        <!-- elong现付担保取消订单 -->
        <button v-show="OrderData.orderInfo.source == 'elong' &&OrderData.orderInfo.paymentInfo.paymentType == 1 &&OrderData.orderInfo.reservationType == 0 &&OrderData.orderInfo.bookingStatus == 'PENDING_CONFIRMATION'" class="s_btn s_btn_small" @click="btnClickType('cancle')">
          {{ $t("CONFIRMATION.BTNCANCEL") }}
        </button>
        <!-- 拒绝取消按钮 -->
        <button v-show="OrderData.orderInfo.bookingStatus == 'CWT_PENDING_CANCELLATION' && this.$objBaseInfo.sourceType == 'CRM'" class="s_btn s_btn_small" @click="btnClickType('refuse')">拒绝取消</button>
        <!-- 支付 -->
        <button v-show="OrderData.orderInfo.bookingStatus == 'PENDING_BOOKING' && OrderData.orderInfo.paymentType == 2" class="s_btn s_btn_small" @click="payLink()">{{ $t("CONFIRMATION.PAYBUTTON") }}</button>
         <!-- 提交审批 -->
         <button v-show="OrderData.orderInfo.bookingStatus == 'CWT_PENDING_APPROVAL' && OrderData.orderInfo.approvalStatus == 0" class="s_btn s_btn_small" @click="submitApproval">{{ $t("CONFIRMATION.SubmitApproval") }}</button>
      </div>
    </div>
    <div class="panel_dividing_line"></div>
    <div class="hotel_info_text" v-if="this.$objBaseInfo.sourceType == 'CRM'">
      <ul>
        <li><span>FX服务热线:4001116664</span></li>
        <li><span>FX邮箱:service@chuxingpay.com</span></li>
      </ul>            
    </div>
    <div class="panel_dividing_line"></div>
    </div>
    <!-- begin price dialog -->
    <el-dialog v-model="showPriceFlag" :title="$t('PRICEDIALOG.TITLE')" :destroy-on-close="true" class="price-dialog">
      <el-divider class="title-divider"></el-divider>
      <!-- <el-tooltip effect="light" :content="rdescription" placement="top-start">
        <div class="add-guest-div" style="margin-top: -42px;width: 40rem;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
          {{ rdescription}}
        </div>
      </el-tooltip> -->
      <span> {{ getProductCode }}</span><br/>
      <span> {{ rdescription }}</span>
      <el-table :data="transData" :show-header="false">
        <el-table-column align="center" fixed>
          <template #default="scope">{{ scope.row[0] }}</template>
        </el-table-column>
        <el-table-column 
          v-for="item in columnLength" 
          :key="item" 
          align="center" 
          :width="130"
        >
          <template #default="scope">{{ scope.row[item] }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog v-model="showMobilePriceFlag" :title="$t('PRICEDIALOG.TITLE')" width="90%" class="price-dialog">
      <el-divider class="title-divider"></el-divider>
      <span> {{ getProductCode }}</span><br/>
      <span> {{ rdescription }}</span>
      <el-table :data="OrderData.originData" max-height="300" style="width: 100%">
        <el-table-column prop="date" align="center" :label="$t('PRICEDIALOG.DATE')"></el-table-column>
        <el-table-column prop="price" align="center" :label="$t('PRICEDIALOG.PRICE')"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- end price dialog -->
    <!-- begin RemarkInfo dialog -->
    <el-dialog :title="$t('REMARKINFO.REMARKLOG')" class="price-dialog" v-model="remarkInfo.showRemarkFlag" :show-close="false">
      <div class="add-guest-div">
        <el-button size="default" class="add-guest-btn" @click="addRemark()">{{ $t("REMARKINFO.ADDREMARK") }}</el-button>
      </div>
      <el-divider class="title-divider"></el-divider>
      <el-table :data="remarkInfo.clientData" class="" width="100%">
        <el-table-column prop="Date" align="center" :label="$t('REMARKINFO.DATE')" min-width="110"></el-table-column>
        <el-table-column prop="Detail" align="center" :label="$t('REMARKINFO.DETAIL')" min-width="180"></el-table-column>
        <el-table-column prop="Operator" align="center" :label="$t('REMARKINFO.OPERATOR')"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- end RemarkInfo dialog -->
    <!-- begin cancel dialog -->
    <el-dialog :title="dialogBtnTitle" v-model="cancelDialogVisible" width="35rem" center class="cancel_dialog">
      <div style="display: flex; align-items: center; justify-content: center; gap: 1rem; width: 100%; text-align: center;" v-if="btnType != 'confirm'">
        <svg-icon v-show="dialogBtnMsg!=''" icon-class="exclamation" class-name="dialog_icon" style="flex: 0 0 auto;"></svg-icon>
        <span style="min-width: 0; max-width: 100%; word-break: break-word; line-height: 1.6;">{{ dialogBtnMsg }}</span>
      </div>
      <el-form :model="cancleForm" ref="cancleForm" class="demo-form-inline">
        <el-form-item :label="$t('CONFIRMATION.BURHOTELCONFIRMNO')" prop="hotelConfirmNo" v-if="btnType == 'confirm'|| btnType == 'editConfirm'"
        :rules="[
          { required: btnType == 'editConfirm', message: '请输入酒店确认单号', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9-]*$/, message: '仅支持录入数字、字母和- ', trigger: 'blur' , },
          { min: 1, max: 30, message: '长度不能超过30位', trigger: 'blur' }
        ]"
        >
          <el-input v-model="cancleForm.hotelConfirmNo" :placeholder="$t('CONFIRMATION.BURHOTELCONFIRMNO')" onkeyup="value=value.replace(/[\u4E00-\u9FA5]/ig, '')"></el-input>
        </el-form-item>
        <!-- 取消订单填写备注 -->
        <el-form-item :label="$t('CONFIRMATION.BURCANCLEREMARK')" prop="hotelConfirmRemark" v-if="remarkFlag && OrderData.orderInfo.source == 'CWTbur' && btnType != 'refuse'">
          <el-input v-model="cancleForm.hotelConfirmRemark" :placeholder="$t('CONFIRMATION.BURCANCLEREMARK')"></el-input>
        </el-form-item>
        <!-- 强制取消订单填写取消原因 -->
        <el-form-item label="取消原因" prop="hotelConfirmRemark" v-if="btnType == 'compulsion'"
        :rules="[
          { required: true, message: '请输入取消原因', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur' }
        ]">
          <el-input v-model.trim="cancleForm.hotelConfirmRemark" placeholder="请输入取消原因"></el-input>
        </el-form-item>
        <!-- 取消拒绝订单填写取消原因 -->
        <el-form-item label="拒绝原因" prop="hotelConfirmRemark" v-if="btnType == 'refuse'"
        :rules="[
          { required: true, message: '请输入拒绝取消原因', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur' }
        ]">
          <el-input v-model.trim="cancleForm.hotelConfirmRemark" placeholder="请输入拒绝原因"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer cancel-dialog-footer">
          <button class="s_btn btn_dialog cancel-dialog-button" @click="cancelOrder">{{ $t("MESSAGE.CONFIRMBUTTONTEXT") }}</button>
          <button class="dialog_btn_n btn_dialog cancel-dialog-button" @click="cancelDialogVisible = false">{{ $t("MESSAGE.CONFIRMCANCELTEXT") }}</button>
        </span>
      </template>
    </el-dialog>
    <!-- end cancel dialog -->
     <!-- begin 修改服务费 dialog -->
    <el-dialog :title="dialogBtnTitle" v-model="servicePayDialogVisible"
    :close-on-click-modal="false" :close-on-press-escape="false"
     width="40rem" center class="cancel_dialog">
      <el-form :model="servicePayForm" ref="servicePayForm" class="demo-form-inline">
        <!-- 选择服务费类型 -->
        <el-form-item label="费用类型" prop="serviceDialogRadio">
          <el-radio-group v-model="servicePayForm.serviceDialogRadio" @change="handleRadioChange">
            <el-radio label="2">服务费</el-radio>
            <el-radio label="3" style="margin-left:2rem;">紧急服务费</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 填写金额 -->
        <el-form-item style="padding-top:10px" label="金额" prop="serviceDialogFee" :rules="[
          { required: true, message: '请输入具体金额', trigger: 'blur' },
          { pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/, message: '仅支持录入数字,最多两位小数', trigger: 'blur' , },
        ]">
          <el-input v-model.trim="servicePayForm.serviceDialogFee" placeholder="金额"  type="number"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <button class="s_btn btn_dialog" @click="updateServiceDialog(servicePayForm.serviceDialogRadio)">提交</button>
          <button class="dialog_btn_n btn_dialog" @click="servicePayDialogVisible = false">关闭</button>
        </span>
      </template>
    </el-dialog>
    <!-- end 修改服务费 dialog -->
    <!-- begin 修改行程单 dialog -->
    <el-dialog v-model="changeApprovedDataDialog" :title="$t('CONFIRMATION.ROOMINFO')" :destroy-on-close="true" class="price-dialog" width="50rem">
      <el-divider class="title-divider"></el-divider>
      <el-form :model="approvedData" :rules="approvedDataRules" ref="approvedData">
        <el-form-item :label="$t('CONFIRMATION.BEDTYPE1')" :label-width="formLabelWidth" class="form_item">
          <el-select v-model="approvedData.bedType" style="width:60%" @change="changeBedType">
            <el-option v-for="item in bedTypeInfo" :key="item.value" :label="item.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CONFIRMATION.BEDTYPECN')" :label-width="formLabelWidth" class="form_item" v-if="showOtherBedType" prop="bedType_CN">
          <el-input v-model="approvedData.bedType_CN" style="width:60%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('CONFIRMATION.BEDTYPEEN')" :label-width="formLabelWidth" class="form_item" v-if="showOtherBedType" prop="bedType_EN">
          <el-input v-model="approvedData.bedType_EN" style="width:60%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('CONFIRMATION.BREAKFAST')" :label-width="formLabelWidth" class="form_item">
          <el-select v-model="approvedData.breakfast" style="width:60%;">
            <el-option v-for="item in breakfastInfo" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <button class="s_btn btn_dialog" @click="saveApproveData">{{ $t("MESSAGE.CONFIRMBUTTONTEXT") }}</button>
          <button class="dialog_btn_n btn_dialog" @click="changeApprovedDataDialog = false">{{ $t("MESSAGE.CONFIRMCANCELTEXT") }}</button>
        </span>
      </template>
    </el-dialog>
    <!-- end 修改行程单 dialog -->
  </div>
<!--end right info-->
</template>
<script>
import {
  updateServiceCharge,
  updateServiceChargeToPay,
  updatePnrAndConfirmationNo,
  getRemarkInfo,
  createRemarkInfo,
  cancelBooking,
  cancelPendingBooking,
  bookingsUpdate,
  refuseBooking,
  confirmUpdate,
  updateApprovedData
} from "@/api/bookingData.js";
import {formatDateTime,} from "@/utils/utils.js";
import { jumpLogin } from "@/api/platformData.js";
export default {
  name: "confirmationRight",
  inject: ['OrderData'],
  data(){
    return {
      originTitle: [],
      columnLength: 0,
      transData: [],
      showPriceFlag: false,
      showMobilePriceFlag: false,
      remarkInfo: {
        showRemarkFlag: false,
        clientData: [],
      },
      dialogBtnTitle: "",
      cancelDialogVisible: false,
      servicePayDialogVisible: false,
      servicePayForm: {
        serviceDialogRadio: "2",
        serviceDialogFee: 0,
      },
      dialogBtnMsg: "",
      remarkFlag: false,
      cancleForm: {
        hotelConfirmRemark: "",
        hotelConfirmNo: "",
      },
      btnType: "",
      breakfastInfo: [
        { value: 0, label: this.$t("BOOKING.NOBREAKFAST"),},
        { value: 99, label: this.$t("BOOKING.BREAKFAST99"),},
        { value: 1, label: this.$t("BOOKING.BREAKFASTNUM", {num: 1,}),},
        { value: 2, label: this.$t("BOOKING.BREAKFASTNUM", {num: 2,}),},
        { value: 3, label: this.$t("BOOKING.BREAKFASTNUM", {num: 3,}),},
        { value: 4, label: this.$t("BOOKING.BREAKFASTNUM", {num: 4,}),},
        { value: 5, label: this.$t("BOOKING.BREAKFASTNUM", {num: 5,}),},
        { value: 100, label: this.$t("BOOKING.BREAKFASTUNKNOWN"),},
      ],
      hotelConfirmationNo:"",// 酒店确认单号
      defaultImg:'this.src="' + require("@/assets/img/hotel_img_error.png") + '";this.onerror=null;',
      changeApprovedDataDialog:false,
      showOtherBedType:false,
      approvedData:{
        bedType:"",
        breakfast:"",
        bedType_CN:"",
        bedType_EN:"",
      },
      formLabelWidth:"130px",
      sabreBreakfastTitle:"",
      bedTypeInfo: [
        {value: 0,label: { "zh-CN": "标准房双床", en: "Standard Room Twin Beds" },},
        {value: 1,label: { "zh-CN": "高级大床房", en: "Superior Room King Bed" },},
        {value: 2,label: { "zh-CN": "高级双床房", en: "Superior Room Twin Beds" },},
        {value: 3,label: { "zh-CN": "豪华大床房", en: "Deluxe Room King Bed" },},
        {value: 4,label: { "zh-CN": "豪华双床房", en: "Deluxe Room Twin Beds" },},
        {value: 5,label: { "zh-CN": "豪华套房", en: "Deluxe Suite" },},
        {value: 6,label: { "zh-CN": "行政大床房", en: "Executive Room King Bed" },},
        {value: 7,label: { "zh-CN": "行政双床房", en: "Executive Room Twin Beds" },},
        {value: 8,label: { "zh-CN": "行政套房", en: "Executive Suite" },},
        {value: 9,label: { "zh-CN": "其他", en: "Other" },},
      ],
      menuFunCode:"",
    }
  },
  created() {
    this.hotelConfirmationNo=this.OrderData.orderInfo.hotelConfirmationNo;
  },
  computed:{
    rdescription(){
      if (this.OrderData.orderInfo.extendInfo !=undefined && this.OrderData.orderInfo.extendInfo.length > 0) {
          let rdescription = this.OrderData.orderInfo.extendInfo.find(item => item.name == "rdescription");
          if(rdescription != null && rdescription != undefined)
          {
            if(rdescription.valueInfo.length > 0){
              return rdescription.valueInfo[0]["rdescription"];
            }
          }
      }
      return "";
    },
    getProductCode(){
      if (this.OrderData.orderInfo.extendInfo !=undefined && this.OrderData.orderInfo.extendInfo.length > 0) {
        let productCode = this.OrderData.orderInfo.extendInfo.find(item => item.name == "productCode");
          if(productCode != null && productCode != undefined){
            if(productCode.valueInfo.length > 0){
              return this.$t("BOOKING.productCode", { productCode: productCode.valueInfo[0]["productCode"] });
            }
          }
      }
      return "";
    },
    approvedDataRules() {
      return {
        bedType_CN: [
          { required: true, message: this.$t("MANUAL.VALIDATEROOMTYPENAME"), trigger: ["blur", "change"], },
          { max: 50, message: this.$t("BANNERINFO.VALIDATELENGTH",{max : 50}), trigger: ["blur", "change"],}
        ],
        bedType_EN: [
          { required: true, message: this.$t("MANUAL.VALIDATEROOMTYPENAME"), trigger: ["blur", "change"], },
          { max: 50, message: this.$t("BANNERINFO.VALIDATELENGTH",{max : 50}), trigger: ["blur", "change"],}
        ],
      };
    },
    showRoomName(){
      if(Object.prototype.hasOwnProperty.call(this.OrderData.orderInfo, "cwtadditionalRoomInfo")) {
        let item = JSON.parse(this.OrderData.orderInfo.cwtadditionalRoomInfo);
        return item.RoomTypeName[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
      }else{
        return this.OrderData.roomInfo.name == null? "": this.OrderData.roomInfo.name[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")]
      }
    },
    showBreakfast(){
      var isUpdate = false;
      if(Object.prototype.hasOwnProperty.call(this.OrderData.orderInfo, "breakfastQuantityCwt")){
        isUpdate = true;
      }
      if(isUpdate){
        if(this.OrderData.orderInfo.breakfastQuantityCwt == 0) {
          return this.$t("BOOKING.NOBREAKFAST");
        }else if(this.OrderData.orderInfo.breakfastQuantityCwt > 0 && this.OrderData.orderInfo.breakfastQuantityCwt < 99){
          return this.$t("BOOKING.BREAKFASTNUM", {num: this.OrderData.orderInfo.breakfastQuantityCwt,})
        }else if(this.OrderData.orderInfo.breakfastQuantityCwt == 99){
          return this.$t("BOOKING.BREAKFAST99");
        }
      }else{

        if (Object.prototype.hasOwnProperty.call(this.OrderData.orderInfo, "sabreBreakfast")) {
          if (this.OrderData.orderInfo.sabreBreakfast) {
             return this.$t("BOOKING.BREAKFAST99");
          }
          else {
             return this.$t("BOOKING.NOBREAKFAST");
          }

        }
        else {
          if (this.OrderData.orderInfo.breakfastQty == 0) {
            return this.$t("BOOKING.NOBREAKFAST");
          } else if (this.OrderData.orderInfo.breakfastQty > 0 && this.OrderData.orderInfo.breakfastQty < 99) {
            return this.$t("BOOKING.BREAKFASTNUM", { num: this.OrderData.orderInfo.breakfastQty, });
          } else if (this.OrderData.orderInfo.breakfastQty == 99) {
            return this.$t("BOOKING.BREAKFAST99");
          }
        }
      }
    },
    showTotalPrice(){
      var totalPrice = 0;
      var roomFree = isNaN(parseFloat(this.OrderData.orderInfo.totalPrice))?0:parseFloat(this.OrderData.orderInfo.totalPrice);
      var exchangeRate = isNaN(parseFloat(this.OrderData.orderInfo.exchangeRate))?0:parseFloat(this.OrderData.orderInfo.exchangeRate);
      var advancePayment = isNaN(parseFloat(this.OrderData.orderInfo.advancePayment))?0:parseFloat(this.OrderData.orderInfo.advancePayment);
      var emergencyServiceFee = isNaN(parseFloat(this.OrderData.orderInfo.emergencyServiceFee))?0:parseFloat(this.OrderData.orderInfo.emergencyServiceFee);
      var serviveFeesAmount = isNaN(parseFloat(this.OrderData.orderInfo.serviceFees.amount))?0:parseFloat(this.OrderData.orderInfo.serviceFees.amount);
      var cardSwipeFee = isNaN(parseFloat(this.OrderData.orderInfo.paymentInfo.swipePrice))?0:parseFloat(this.OrderData.orderInfo.paymentInfo.swipePrice);
      totalPrice=  roomFree * exchangeRate + advancePayment + emergencyServiceFee + serviveFeesAmount + cardSwipeFee;
      return totalPrice.toFixed(2);
    },
    separator() {
      return "| ";
    }
  },
  watch: {
    "OrderData.orderInfo.hotelConfirmationNo"(newVal, oldVal) {
      if (oldVal!=0 && newVal != oldVal) {
        this.hotelConfirmationNo=newVal;
     }
    },
  },
  methods: {
    showHotelName(hotelName) {
      if(this.$objBaseInfo?.sourceType == "CRM") {
        if(this.OrderData?.isGATCity || this.OrderData?.orderInfo?.isInternational) {
          return hotelName["zh-CN"] + '(' + hotelName["en"] + ')';
        }
      }
      return hotelName[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
    },
    showHotelAddress(hotelAddress) {
      if(this.$objBaseInfo?.sourceType == "CRM") {
        if(this.OrderData?.isGATCity || this.OrderData?.orderInfo?.isInternational) {
          return hotelAddress["zh-CN"] + '(' + hotelAddress["en"] + ')';
        }
      }
      return hotelAddress[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
    },
    handleRadioChange(value) {
      // 根据选中值执行不同逻辑
      if (value === '2') {
        // 选中服务费
        this.servicePayForm.serviceDialogFee=this.OrderData.serviceFees_original;
      } else if (value === '3') {
        // 选中紧急服务费
        this.servicePayForm.serviceDialogFee=this.OrderData.emergencyServiceFee_original;
      }
    },
    openServiceDialog() {
      if (this.servicePayForm.serviceDialogRadio == '2') {
        // 选中服务费
        this.servicePayForm.serviceDialogFee=this.OrderData.serviceFees_original;
      } else if (this.servicePayForm.serviceDialogRadio === '3') {
        // 选中紧急服务费
        this.servicePayForm.serviceDialogFee=this.OrderData.emergencyServiceFee_original;
      }
      this.servicePayDialogVisible = true;
    },
    updateServiceDialog(type)
    {
       if (type == 2){
        this.OrderData.orderInfo.serviceFees.amount=this.servicePayForm.serviceDialogFee;
        this.OrderData.orderInfo.emergencyServiceFee=this.OrderData.emergencyServiceFee_original;
      }
      if (type == 3){
        this.OrderData.orderInfo.emergencyServiceFee=this.servicePayForm.serviceDialogFee;
        this.OrderData.orderInfo.serviceFees.amount=this.OrderData.serviceFees_original;
      }
      this.$refs.servicePayForm.validate(valid => {
        if (valid) {
          // 校验通过，执行提交逻辑
          this.updateServiceChargeAndBreakfastQty(type);
          this.servicePayDialogVisible = false;
        } else {
          // 校验失败，提示用户
          return false;
        }
      });
    },
    // 1:早餐数量 2：服务费 3：紧急服务费
    updateServiceChargeAndBreakfastQty(type) {
      var tips = this.$t("SERVICECHARGEINFO.TIPS");
      if (type == 1){
        tips = tips + "早餐?";
      }
      if (type == 2){
        tips = tips + "服务费?";
      }
      if (type == 3){
        tips = tips + "紧急服务费?";
      }
      if (type == 2 || type == 3) {
        if (this.OrderData.orderInfo.paymentType == 1 
        && this.OrderData.orderInfo.paymentInfo.isOpenCTAPayService
        ) {
          this.updateServiceChargeToPay(type);
          return false;
        }
      }
      this.$confirm(tips,
        this.$t("SERVICECHARGEINFO.HINT"),
        {
          confirmButtonText: this.$t("MESSAGE.CONFIRMBUTTONTEXT"),
          cancelButtonText: this.$t("MESSAGE.CONFIRMCANCELTEXT"),
          type: "warning",
        }
      )
        .then(() => {
          this.OrderData.orderInfo.emergencyServiceFee =
            this.OrderData.orderInfo.emergencyServiceFee == ""
              ? 0
              : this.OrderData.orderInfo.emergencyServiceFee;
          this.OrderData.orderInfo.serviceFees.amount =
            this.OrderData.orderInfo.serviceFees.amount == ""
              ? 0
              : this.OrderData.orderInfo.serviceFees.amount;
          if (
            this.OrderData.orderInfo.emergencyServiceFee !=
              this.OrderData.emergencyServiceFee_original ||
            this.OrderData.orderInfo.serviceFees.amount != this.OrderData.serviceFees_original||
            this.OrderData.breakfastData != this.OrderData.breakfastQty_original
          ) {
            let serviceChargeParam = {
              BookingCode: this.OrderData.orderInfo.bookingId,
              BookingStatus: this.OrderData.orderInfo.bookingStatus,
              EmergencyServiceFee: this.OrderData.orderInfo.emergencyServiceFee,
              ServiceFees: this.OrderData.orderInfo.serviceFees.amount,
              BreakfastInfo: this.OrderData.breakfastData,
              EmergencyServiceFee_original: this.OrderData.emergencyServiceFee_original,
              BreakfastInfo_original: this.OrderData.breakfastQty_original,
              ServiceFees_original: this.OrderData.serviceFees_original,
            };
            updateServiceCharge(serviceChargeParam)
              .then((res) => {
                if (res.code == 200) {
                  if (!res.data) {
                    this.OrderData.confirmFlag = true;
                    this.OrderData.confirmMsg = this.$t(
                      "SERVICECHARGEINFO.SERVICECHARGEERROR"
                    );
                    this.OrderData.orderDetail();
                  } else {
                    this.OrderData.confirmFlag = true;
                    this.OrderData.confirmMsg = this.$t(
                      "SERVICECHARGEINFO.SERVICECHARGESUCCESS"
                    );
                    this.OrderData.orderDetail();
                  }
                }
              })
              .catch(function (error) {
                console.log("修改服务费 请求失败", error);
              });
          }
        })
        .catch(() => {
          this.OrderData.orderInfo.emergencyServiceFee =
            this.OrderData.emergencyServiceFee_original;
          this.OrderData.orderInfo.serviceFees.amount = this.OrderData.serviceFees_original;
          this.OrderData.breakfastData = this.OrderData.breakfastQty_original
        });
    },
    updateServiceChargeToPay(type) {
      this.OrderData.orderInfo.emergencyServiceFee =
        this.OrderData.orderInfo.emergencyServiceFee == ""
          ? 0
          : this.OrderData.orderInfo.emergencyServiceFee;
      this.OrderData.orderInfo.serviceFees.amount =
        this.OrderData.orderInfo.serviceFees.amount == ""
          ? 0
          : this.OrderData.orderInfo.serviceFees.amount;
      if (
        !(this.OrderData.orderInfo.emergencyServiceFee !=
          this.OrderData.emergencyServiceFee_original ||
          this.OrderData.orderInfo.serviceFees.amount != this.OrderData.serviceFees_original)
      ) {
        return;
      }
      if(this.OrderData.orderInfo.bookingStatus != 'BOOKED')
      {
        this.OrderData.confirmFlag = true;
        this.OrderData.confirmMsg = '该订单状态不支持修改服务费';
        return false;
      }
      if ((this.OrderData.emergencyServiceFee_original > 0 && type==3) || (this.OrderData.serviceFees_original > 0 && type==2)) {
        this.OrderData.confirmFlag = true;
        this.OrderData.confirmMsg = '该订单不支持二次修改服务费';
        return false;
      }
      var tips = '更新服务费金额将会触发扣款操作，请确认是否更新';
      this.$confirm(tips,
        this.$t("SERVICECHARGEINFO.HINT"),
        {
          confirmButtonText: this.$t("MESSAGE.CONFIRMBUTTONTEXT"),
          cancelButtonText: this.$t("MESSAGE.CONFIRMCANCELTEXT"),
          type: "warning",
          beforeClose:(action, instance, done) => {
            if (action === 'confirm') {
              this.OrderData.detailLoading = true;
              done(); // 关闭对话框
            }
            else {
              done(); // 处理取消操作
            }
          },
        }
      )
        .then(() => {
          if (
            this.OrderData.orderInfo.emergencyServiceFee !=
            this.OrderData.emergencyServiceFee_original ||
            this.OrderData.orderInfo.serviceFees.amount != this.OrderData.serviceFees_original
          ) {
            this.OrderData.detailLoading = true;
            let serviceChargeParam = {
              BookingCode: this.OrderData.orderInfo.bookingId,
              BookingStatus: this.OrderData.orderInfo.bookingStatus,
              EmergencyServiceFee: this.OrderData.orderInfo.emergencyServiceFee,
              ServiceFees: this.OrderData.orderInfo.serviceFees.amount,
              EmergencyServiceFee_original: this.OrderData.emergencyServiceFee_original,
              ServiceFees_original: this.OrderData.serviceFees_original,
            };
            updateServiceChargeToPay(serviceChargeParam)
              .then((res) => {
                this.OrderData.detailLoading = false;
                if (res.code == 200) {
                  if (res.data.code == "0") {
                    this.OrderData.confirmFlag = true;
                    this.OrderData.confirmMsg = this.$t(
                      "SERVICECHARGEINFO.SERVICECHARGESUCCESS"
                    );
                    this.OrderData.orderDetail();
                  } else {
                    this.OrderData.confirmFlag = true;
                    this.OrderData.confirmMsg = res.data.msg;
                    this.OrderData.orderDetail();
                  }
                }
              })
              .catch(function (error) {
                this.OrderData.detailLoading = false;
                console.log("修改服务费 请求失败", error);
              });
          }
        })
        .catch(() => {
          this.OrderData.orderInfo.emergencyServiceFee =
            this.OrderData.emergencyServiceFee_original;
          this.OrderData.orderInfo.serviceFees.amount = this.OrderData.serviceFees_original;
          this.OrderData.breakfastData = this.OrderData.breakfastQty_original
        });
    },
    //清除服务费非两位小数的值
    clearNoNumTotalPrice() {
      this.OrderData.orderInfo.serviceFees.amount =
      this.OrderData.orderInfo.serviceFees.amount.replace(/^\./g, ""); // 验证第一个字符是数字而不是点
      this.OrderData.orderInfo.serviceFees.amount =
      this.OrderData.orderInfo.serviceFees.amount.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      this.OrderData.orderInfo.serviceFees.amount =
      this.OrderData.orderInfo.serviceFees.amount.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.OrderData.orderInfo.serviceFees.amount = this.OrderData.orderInfo.serviceFees.amount
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.OrderData.orderInfo.serviceFees.amount =
      this.OrderData.orderInfo.serviceFees.amount.replace(
            /^(\-)*(\d+)\.(\d\d).*$/,
            "$1$2.$3"
        ); //只能输入两个小数
      this.OrderData.orderInfo.serviceFees.amount = this.OrderData.orderInfo.serviceFees.amount
        .replace(/^0+\./g, "0.")
        .replace(/^0+([0-9])/, "$1"); //清除.前面无效的0
      if (this.OrderData.orderInfo.serviceFees.amount.indexOf(".") < 0 &&this.OrderData.orderInfo.serviceFees.amount != "") {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.OrderData.orderInfo.serviceFees.amount = parseFloat(this.OrderData.orderInfo.serviceFees.amount);
      }
    },
    //清除紧急服务费非两位小数的值
    clearNoNumUrgentfee() {
      this.OrderData.orderInfo.emergencyServiceFee =
        this.OrderData.orderInfo.emergencyServiceFee.replace(/^\./g, ""); // 验证第一个字符是数字而不是点
      this.OrderData.orderInfo.emergencyServiceFee =
        this.OrderData.orderInfo.emergencyServiceFee.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      this.OrderData.orderInfo.emergencyServiceFee =
        this.OrderData.orderInfo.emergencyServiceFee.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.OrderData.orderInfo.emergencyServiceFee = this.OrderData.orderInfo.emergencyServiceFee
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.OrderData.orderInfo.emergencyServiceFee =
        this.OrderData.orderInfo.emergencyServiceFee.replace(
          /^(\-)*(\d+)\.(\d\d).*$/,
          "$1$2.$3"
        ); //只能输入两个小数
      this.OrderData.orderInfo.emergencyServiceFee = this.OrderData.orderInfo.emergencyServiceFee
        .replace(/^0+\./g, "0.")
        .replace(/^0+([0-9])/, "$1"); //清除.前面无效的0
      if (
        this.OrderData.orderInfo.emergencyServiceFee.indexOf(".") < 0 &&
        this.OrderData.orderInfo.emergencyServiceFee != ""
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.OrderData.orderInfo.emergencyServiceFee = parseFloat(
          this.OrderData.orderInfo.emergencyServiceFee
        );
      }
    },
    // 同步酒店pnr和确认单号
    async UpdatePnrConfirmationNo(type) {
      this.OrderData.detailLoading = true;
      let Params = {
      params: {
        bookingId: this.OrderData.orderInfo.bookingId,
      }
      };
      await updatePnrAndConfirmationNo(Params)
      .then((res) => {
        this.OrderData.detailLoading = false;
          if (res.code == 200) {
            if (res.data.error.code == 0) {
              let orderDetails=res.data;
              let flag=false;
              if(orderDetails.hotelConfirmationNo!="" || orderDetails.hotelConfirmationNo!=null || orderDetails.hotelConfirmationNo!=undefined){
                this.OrderData.orderInfo.hotelConfirmationNo=orderDetails.hotelConfirmationNo;
                this.OrderData.isShowSyncHotelConfirmationNo=false;
                flag=true;
              }
              if(orderDetails.sourceBookingId!="" || orderDetails.sourceBookingId!=null || orderDetails.sourceBookingId!=undefined){
                this.OrderData.orderInfo.sourceBookingId=orderDetails.sourceBookingId;
                this.OrderData.isShowSyncPnr=false;
                flag=true;
              }
              if(!flag){
                this.OrderData.confirmFlag = true;
                this.OrderData.confirmMsg ="同步失败,供应商未提供该信息";
              }
            }else {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg ="同步失败";
            }
          }else {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg ="同步失败";
          }
      })
      .catch((err) => {
        this.OrderData.detailLoading = false;
        this.OrderData.confirmFlag = true;
        this.OrderData.confirmMsg ="同步失败";
        console.log("同步pnr和酒店确认单号失败:", err.objError);
      });
    },
    //点击按钮
    btnClickType(type) {
      this.btnType = type;
      //初始默认为隐藏
      this.remarkFlag = false;
      this.dialogBtnMsg="";
      this.dialogBtnTitle = "";
      if (type == "cancle") {
        this.dialogBtnTitle = this.$t("CONFIRMATION.BTNCANCEL");
        this.dialogBtnMsg = this.$t("CONFIRMATION.CONFIRMMSG");
        // 延时预订
        if (this.OrderData.orderInfo.source == "CWTbur") {
          this.remarkFlag = true;
        } else {
          this.remarkFlag = false;
        }
      }
      if (type == "confirm") {
        //需要输入框填写酒店确认单号
        this.dialogBtnTitle = this.$t("CONFIRMATION.BTNCONFIRM");
      }
      if (type == "reject") {
        this.dialogBtnTitle = this.$t("CONFIRMATION.BTNREJECT");
        this.dialogBtnMsg = this.$t("CONFIRMATION.CONFIRMREJECT");
      }
      if(type=="compulsion")
      {
        this.dialogBtnTitle = this.$t("CONFIRMATION.BTNCANCEL");
        this.dialogBtnMsg = this.$t("CONFIRMATION.CONFIRMMSG");
      }
      if(type=="refuse")
      {
        this.dialogBtnTitle = "拒绝取消订单";
        this.dialogBtnMsg = "是否确认拒绝取消订单？";
      }
      if (type == "editConfirm") {
        if(this.OrderData.orderInfo.hotelConfirmationNo!=undefined && this.OrderData.orderInfo.hotelConfirmationNo!=null)
        {
          this.cancleForm.hotelConfirmNo=this.OrderData.orderInfo.hotelConfirmationNo;
        }
       
        //需要输入框填写酒店确认单号
        this.dialogBtnTitle = this.$t("CONFIRMATION.Edit");
      }
      this.cancleForm.hotelConfirmRemark="";
      this.cancelDialogVisible = true;
    },
    //修改订单
    updateOrderInfo() {
      this.OrderData.$refs["specialRef"].$refs["updateOrderForm"].validate((valid) => {
        if (valid) {
          let miParamList = [];
          //MI信息参数
          for (const key in this.OrderData.miList) {
            const element = this.OrderData.miList[key];
            let miParam = {
              miType: element.pageShow == 1 ? 2 : 1,
              miNameDic: {
                en: "",
                "zh-CN": "",
              },
            };
            miParam.miNameDic["en"] = element.miNameEN;
            miParam.miNameDic["zh-CN"] = element.miNameCN;
            miParam.miCode = element.relationMIKey;
            miParam.miKey = element.relationMIKey;
            miParam.miValue = this.OrderData.updateOrderForm[element.relationMIKey];

            miParam.noteCN = element.noteCN;
            miParam.noteEN = element.noteEN;
            miParam.noteCNLink = element.noteCNLink;
            miParam.noteENLink = element.noteENLink;
            miParam.isSendHotelItinerary = element.isSendHotelItinerary;
            miParam.miGuid=element.miGuid;
            miParam.isAffterHotelApproval=element.isAffterHotelApproval;
            miParamList.push(miParam);
          }
          let params = {
            bookingCode: this.OrderData.orderInfo.bookingId,
            posCode: this.$objBaseInfo.poscode,
            miList: miParamList,
          };
          this.updateOrderStatus(params);
        } else {
          this.OrderData.detailLoading = false;
          return false;
        }
      });
    },
    //取消修改
    cancelUpdate() {
      this.OrderData.isUpdate = false;
      if (this.OrderData.orderInfo.isCancelable ||(this.OrderData.orderInfo.bookingStatus =="CWT_PENDING_CANCELLATION" && this.$objBaseInfo.sourceType == "CRM"))
      {
        this.OrderData.isShowCancel = true;
      } 
      else 
      {
         this.OrderData.isShowCancel = false;
      }
      //this.OrderData.isShowCancel = true;
    },
    payLink() {
      //支付页面传参参数
      let guaranteeParam = {
        hotelName: this.OrderData.hotelInfo.hotelName,
        checkInAt: formatDateTime(this.OrderData.orderInfo.checkInDate, "YYYY-MM-DD"),
        checkOutAt: formatDateTime(this.OrderData.orderInfo.checkOutDate, "YYYY-MM-DD"),
        nights:
          (new Date(this.OrderData.orderInfo.checkOutDate) -
            new Date(this.OrderData.orderInfo.checkInDate)) /
          (24 * 60 * 60 * 1000), // 几晚
        breakfastQty: this.OrderData.breakfastData, // 早餐数量, 0：不含早， 99：含早，不指定具体份数， 1-99： 指定早餐具体份数
        roomCount: this.OrderData.orderInfo.roomCount, //房间数
        totalPrice: this.showTotalPrice,//this.OrderData.orderInfo.totalPrice, //总价
        floor: this.OrderData.orderInfo.roomDescriptiveInfo.floor, //房间楼层
        area: this.OrderData.orderInfo.roomDescriptiveInfo.area, //area
        window: this.OrderData.orderInfo.roomDescriptiveInfo.hasWindow, //window
        wifi: this.OrderData.orderInfo.roomDescriptiveInfo.wifi, //wifi
        roomName: this.OrderData.orderInfo.roomDescriptiveInfo.roomName,
        bookParam: this.OrderData.orderInfo,
        isGAT:this.OrderData.isGATCity,
        supportedCreditCards:
          this.OrderData.orderInfo.paymentInfo.supportedCreditCards == null ||
          this.OrderData.orderInfo.paymentInfo.supportedCreditCards == undefined
            ? ""
            : this.OrderData.orderInfo.paymentInfo.supportedCreditCards,
      };
      sessionStorage.setItem(
        "payOrderInfo",
        JSON.stringify(guaranteeParam)
      );
      this.$router.push({
        name: "PayOrder",
        query: { sourceType: this.$objBaseInfo.sourceType },
      });
    },
    showPriceDialog() {
      if (this.$objBaseInfo.channelId == "WEB") {
        this.originTitle = [];
        // 竖向表格标题
        this.originTitle.push(this.$t("PRICEDIALOG.DATE") + "：");
        this.originTitle.push(this.$t("PRICEDIALOG.PRICE") + "：");
        this.columnLength = this.OrderData.originData.length + 1;
        // 数组按矩阵思路, 变成转置矩阵
        if (this.OrderData.originData.length > 0) {
          let matrixData = this.OrderData.originData.map((row) => {
            let arr = [];
            for (let key in row) {
              arr.push(row[key]);
            }
            return arr;
          });
          // 加入标题拼接最终的数据
          this.transData = matrixData[0].map((col, i) => {
            return [
              this.originTitle[i],
              ...matrixData.map((row) => {
                return row[i];
              }),
            ];
          });
        }
        this.showPriceFlag = true;
      } else {
        this.showMobilePriceFlag = true;
      }
    },
    async showRemarkDialog() {
      this.remarkInfo.showRemarkFlag = true;
      var arrTemp = [];
      let that = this;
      let remarkLogParam = {
        params: {
          bookingCode: this.OrderData.orderInfo.bookingId,
        },
      };
      await getRemarkInfo(remarkLogParam)
        .then((res) => {
          if (res.code == 200) {
            if (res.data != null) {
              for (var i = 0; i < res.data.length; i++) {
                var response = res.data[i];
                const item = {
                  Date: formatDateTime(response.date,"YYYY-MM-DD HH:mm:ss"),
                  Detail: response.detail,
                  Operator: response.operator,
                };
                arrTemp.push(item);
              }
            }
            that.remarkInfo.clientData = arrTemp;
          }
        })
        .catch(function (error) {
          console.log("备注日志 请求失败", error);
        });
    },
    async addRemark() {
      try {
        const { value } = await this.$prompt(this.$t("REMARKINFO.ADDREMARKMSG"), "", {
          confirmButtonText: this.$t("MESSAGE.CONFIRMBUTTONTEXT"),
          cancelButtonText: this.$t("MESSAGE.CONFIRMCANCELTEXT"),
          inputType: "textarea",
          inputValidator: (value) => {
            if (value == undefined || value.trim() === '') {
              return this.$t("REMARKINFO.EMPTYMSG") || "备注信息不能为空";
            } else if (value.length > 300) {
              return this.$t("REMARKINFO.MAXLENGTHMSG") || "只能输入300字符";
            }
            return true;
          },
        });

        let remarkLogParam = {
          BookingCode: this.OrderData.orderInfo.bookingId,
          Detail: value,
        };

        const res = await createRemarkInfo(remarkLogParam);
        
        if (res.code == 200) {
          if (!res.data) {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg = this.$t("REMARKINFO.ADDERRORMSG");
          } else {
            this.showRemarkDialog();
          }
        }
      } catch (error) {
        // 用户点击取消或其他错误
        if (error !== 'cancel') {
          console.log("备注日志 请求失败", error);
        }
      }
    },
    cancelOrder() {
      this.OrderData.detailLoading = true;
      this.cancelDialogVisible = false;
      let updateParams = {
        BookingCode: this.OrderData.orderInfo.bookingId,
        PosCode: this.$objBaseInfo.poscode,
        Source: this.$objBaseInfo.sourceType,
      };
      let cancelParam = {
        reservationNumber: this.OrderData.orderInfo.bookingId,
        cancelReason: this.cancleForm.hotelConfirmRemark,
        posCode: this.$objBaseInfo.poscode,
        isForce:this.btnType == "compulsion"?true:false //是否强制取消
      };
      if (this.btnType == "cancle") {
        if (this.OrderData.orderInfo.source == "CWTbur") {
          // 延时预订
          let Extend = [
            {
              Name: "CancelReason",
              ValueInfo: this.cancleForm.hotelConfirmRemark,
            },
          ];
          cancelParam.extend = Extend;
          cancelParam.source = this.$objBaseInfo.sourceType;
        }
        this.canclePost(cancelParam);
      }
      else if(this.btnType == "compulsion"){//强制取消
        console.log("调用取消接口");
        let remarkLogParam = {
          Detail: this.cancleForm.hotelConfirmRemark,
          Date:new Date(),
          Operator:this.$objBaseInfo.loginID,
        };
        let Extend = [
            {
              Name: "CRM_Remark",
              ValueInfo: JSON.stringify(remarkLogParam)
            },
        ];
        cancelParam.extend = Extend;
        cancelParam.source = this.$objBaseInfo.sourceType;
        this.$refs["cancleForm"].validate((valid) => {
          if (valid) {
            this.canclePost(cancelParam);
          }
          else{
            this.OrderData.detailLoading = false;
            this.cancelDialogVisible = true;
          }
        });
      }
      else if(this.btnType == "refuse"){//拒绝取消
        console.log("调用取消接口");
        let remarkLogParam = {
          Detail: this.cancleForm.hotelConfirmRemark,
          Date:new Date(),
          Operator:this.$objBaseInfo.loginID,
        };
        let Extend = [
            {
              Name: "CRM_Remark",
              ValueInfo: JSON.stringify(remarkLogParam)
            },
        ];
        cancelParam.extend = Extend;
        cancelParam.source = this.$objBaseInfo.sourceType;
        this.$refs["cancleForm"].validate((valid) => {
          if (valid) {
            this.refusePost(cancelParam);
          }
          else{
            this.OrderData.detailLoading = false;
            this.cancelDialogVisible = true;
          }
        });
      }
      else if(this.btnType == "editConfirm"){//修改酒店确认单号
        console.log("修改酒店确认单号");
        updateParams.crsReservationNumber = this.cancleForm.hotelConfirmNo;
        this.$refs["cancleForm"].validate((valid) => {
          if (valid) {
            this.EditConfirm(updateParams);
          }
          else{
            this.OrderData.detailLoading = false;
            this.cancelDialogVisible = true;
          }
        });
      }
      else{
        if (this.btnType == "confirm") {
          // 酒店订单hotelConfirmNo
          updateParams.BookingStatus = "BOOKED";
          updateParams.CrsReservationNumber = this.cancleForm.hotelConfirmNo;
          this.$refs["cancleForm"].validate((valid) => {
          if (valid) {
            this.updateOrderStatus(updateParams);
          }
          else{
            this.OrderData.detailLoading = false;
            this.cancelDialogVisible = true;
          }
        });
        } else if (this.btnType == "reject") {
          // CHOM-2927:BUR订单被拒绝没预定成功的，订单状态改为预定失败
          updateParams.BookingStatus = "BOOKING_FAILED";
          this.updateOrderStatus(updateParams);
        }
      }
    },
    async canclePost(cancelParam) {
      await cancelBooking(cancelParam)
        .then((res) => {
          this.OrderData.detailLoading = false;
          if (res.code == 200) {
            if (res.data.error.code != 0) {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg =
                this.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "取消订单失败, code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              this.OrderData.isRefresh = true;
              this.OrderData.confirmFlag = true;
              if (this.btnType == "cancle") {
                this.OrderData.confirmMsg = this.$t("CONFIRMATION.ORDERCANCLESUCCESS");
                if (
                  (this.OrderData.orderInfo.source == "CWTbur" || this.OrderData.orderInfo.isManualOrder)&& 
                  this.$objBaseInfo.sourceType == "OBT"
                ) {
                  this.OrderData.confirmMsg = this.$t("CONFIRMATION.BURCANCLETIPS");
                }
                if (
                  (this.OrderData.orderInfo.source == "CWTbur" || this.OrderData.orderInfo.isManualOrder)&& 
                  this.$objBaseInfo.sourceType == "CRM" && 
                  this.OrderData.orderInfo.bookingStatus == "BOOKED"
                ) {
                  this.OrderData.confirmMsg ='您已提交订单取消申请，请您致电人工客服处理。';
                }
              }
              else if(this.btnType == "compulsion"){
                this.OrderData.confirmMsg = this.$t("CONFIRMATION.ORDERCANCLESUCCESS");
              }
              else {
                this.OrderData.confirmMsg = this.$t("CONFIRMATION.ORDERREJECTSUCCESS");
              }
            }
          } else {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg =
              this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? this.$t("ERRORMESSAGE.NOTFOUND")
                : this.$t("ERRORMESSAGE." + res.code);
            console.log("取消订单失败,code:" + res.code, res.message);
          }
        })
        .catch((err) => {
          this.OrderData.detailLoading = false;
          this.OrderData.confirmFlag = true;
          this.OrderData.confirmMsg = this.$t("ERRORMESSAGE." + err.mesCode);
          console.log("取消订单失败:", err.objError);
        });
    },
    async cancelPendingBookingPost() {
      this.OrderData.detailLoading = true;
      let cancelParam = {
        reservationNumber: this.OrderData.orderInfo.bookingId
      };
      await cancelPendingBooking(cancelParam)
        .then((res) => {
          this.OrderData.detailLoading = false;
          if (res.code == 200) {
            if (res.data.error.code != 0) {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg =
                this.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "取消订单失败, code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              this.OrderData.isRefresh = true;
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg = this.$t("CONFIRMATION.ORDERCANCLESUCCESS");
            }
          } else {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg =
              this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? this.$t("ERRORMESSAGE.NOTFOUND")
                : this.$t("ERRORMESSAGE." + res.code);
            console.log("取消订单失败,code:" + res.code, res.message);
          }
        })
        .catch((err) => {
          this.OrderData.detailLoading = false;
          this.OrderData.confirmFlag = true;
          this.OrderData.confirmMsg = this.$t("ERRORMESSAGE." + err.mesCode);
          console.log("取消订单失败:", err.objError);
        });
    },
    async updateOrderStatus(params) {
      await bookingsUpdate(params)
        .then((res) => {
          this.OrderData.detailLoading = false;
          if (res.code == 200) {
            if (res.data.error.code != 0) {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg =
                this.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "修改订单失败, code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              this.OrderData.isRefresh = true;
              if (this.btnType == "confirm") {
                this.OrderData.confirmMsg = this.$t("CONFIRMATION.ORDERCONFIRMSUCCESS");
              } else if (this.btnType == "reject") {
                this.OrderData.confirmMsg = this.$t("CONFIRMATION.ORDERREJECTSUCCESS");
              } else {
                this.OrderData.confirmMsg = this.$t("CONFIRMATION.ORDERUPDATESUCCESS");
              }
              this.OrderData.confirmFlag = true;
            }
          } else {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg =
              this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? this.$t("ERRORMESSAGE.NOTFOUND")
                : this.$t("ERRORMESSAGE." + res.code);
            console.log("修改订单失败,code:" + res.code, res.message);
          }
        })
        .catch((err) => {
          this.OrderData.detailLoading = false;
          this.OrderData.confirmFlag = true;
          this.OrderData.confirmMsg = this.$t("ERRORMESSAGE." + err.mesCode);
          console.log("修改订单异常:", err.objError);
        });
    },
    // 拒绝取消订单
    async refusePost(cancelParam) {
      await refuseBooking(cancelParam)
        .then((res) => {
          this.OrderData.detailLoading = false;
          if (res.code == 200) {
            if (res.data.error.code == 0) {
              this.OrderData.isRefresh = true;
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg = this.$t("CONFIRMATION.ORDERREJECTSUCCESS");
            } else {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg =
                this.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + res.data.error.code);
            }
          }
           else {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg =
              this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? this.$t("ERRORMESSAGE.NOTFOUND")
                : this.$t("ERRORMESSAGE." + res.code);
          }
        })
        .catch((err) => {
          this.OrderData.detailLoading = false;
          this.OrderData.confirmFlag = true;
          this.OrderData.confirmMsg = this.$t("ERRORMESSAGE." + err.mesCode);
          console.log("取消订单失败:", err.objError);
        });
    },
    // 修改酒店确认单号
    async EditConfirm(param) {
      await confirmUpdate(param)
        .then((res) => {
          this.OrderData.detailLoading = false;
          if (res.code == 200) {
            if (res.data.error.code == 0) {
              //this.OrderData.orderInfo.hotelConfirmationNo=param.crsReservationNumber;
              this.hotelConfirmationNo=param.crsReservationNumber;
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg =this.$t("SERVICECHARGEINFO.SERVICECHARGESUCCESS");
            } else {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg = this.$t("SERVICECHARGEINFO.SERVICECHARGEERROR");
            }
          }
           else {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg =this.$t("SERVICECHARGEINFO.SERVICECHARGEERROR");
          }
        })
        .catch((err) => {
          this.OrderData.detailLoading = false;
          this.OrderData.confirmFlag = true;
          this.OrderData.confirmMsg = this.$t("SERVICECHARGEINFO.SERVICECHARGEERROR");
        });
    },
    changeApprovedData(){
      this.approvedData.bedType = this.showRoomName;//this.OrderData.roomInfo.name == null? "": this.OrderData.roomInfo.name[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
      this.approvedData.breakfast = this.OrderData.breakfastData;
      console.log(this.approvedData.breakfast);
      this.showOtherBedType = false;
      this.changeApprovedDataDialog = true;
    },
    changeBedType(){
      if(this.approvedData.bedType == 9){
        this.showOtherBedType = true;
      }else{
        this.showOtherBedType = false;
      }
    },
    saveApproveData(){
      this.$refs["approvedData"].validate((valid) => {
        if(valid){
          var typeName = {"en": "","zh-CN": ""};;
          if(this.approvedData.bedType == 9){
            typeName["en"] = this.approvedData.bedType_EN;
            typeName["zh-CN"] = this.approvedData.bedType_CN;
          }else{
            var originalBedType = this.showRoomName;
            if(originalBedType == this.approvedData.bedType){
              if(Object.prototype.hasOwnProperty.call(this.OrderData.orderInfo, "cwtadditionalRoomInfo")) {
                let item = JSON.parse(this.OrderData.orderInfo.cwtadditionalRoomInfo);
                typeName = item.RoomTypeName;
              }else{
                typeName = this.OrderData.roomInfo.name;
              }
            }else{
              typeName = this.bedTypeInfo[this.approvedData.bedType].label;
            }
          }
          let param = {
            bookingCode: this.OrderData.orderInfo.bookingId,
            bookingStatus: this.OrderData.orderInfo.bookingStatus,
            breakfastInfo_original: this.OrderData.breakfastData,
            breakfastQuantityCwt: this.approvedData.breakfast,
            roomTypeName: Object.prototype.hasOwnProperty.call(this.OrderData.orderInfo, "cwtadditionalRoomInfo")? JSON.parse(this.OrderData.orderInfo.cwtadditionalRoomInfo).RoomTypeName : this.OrderData.roomInfo.name,
            CwtRoomTypeName: typeName,
          }
          updateApprovedData(param).then((res) => {
            if (res.code == 200 && res.data) {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg =this.$t("CONFIRMATION.ORDERUPDATESUCCESS");
              this.OrderData.orderDetail();
              this.changeApprovedDataDialog = false;
            }
            else {
              this.OrderData.confirmFlag = true;
              this.OrderData.confirmMsg =this.$t("CONFIRMATION.ORDERMODIFYFAILED");
            }
          })
          .catch((err) => {
            this.OrderData.confirmFlag = true;
            this.OrderData.confirmMsg = this.$t("CONFIRMATION.ORDERMODIFYFAILED");
          });
        }
      })
    },
    submitApproval(){
      const previousPage = sessionStorage.getItem('previousPage');
      if(this.$objBaseInfo.sourceType == "OBT" && (previousPage == "Booking" || previousPage == "Guarantee" || previousPage == "EGuarantee")){
        this.menuFunCode = this.$objBaseInfo.jumpType == "H5"?"MenuFL10":"FL051"
        this.getSSOUrl(this.menuFunCode)
      }else{
        let message = {};
        message.data = "confirmation";
        message.orderNo = this.OrderData.orderInfo.bookingId;
        window.parent.postMessage(message, "*");
      }
    },
    async getSSOUrl(menuCode) {
      let jumpParams = {
        params: {
          jumpType: this.$objBaseInfo.jumpType,
          menuFunCode: menuCode,
        },
      };
      await jumpLogin(jumpParams)
        .then((res) => {
          if (res.code == 200) {
            window.location.href = res.data;
          } else {
            console.log("OBT菜单转sso跳转失败", res);
          }
        });
    },
  }
}
</script>
<style lang="stylus" scoped>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .panel_bg {
    background-color: #FFF;
  }

  .hotel_info {
    display: flex;
  }

  .div_hotel_info_img {
    width: 70%;
  }

  .hotel_info_img {
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
  }

  .hotel_info_text {
    padding: 1.3rem;
    width: 100%;

    ul {
      display: flex;
      flex-direction: column;
      font-size: 1.4rem;

      li {
        line-height: 2rem;
        padding-bottom: 1.2rem;
        display: inline-block;

        h1 {
          display: inline;
          font-size: 1.8rem;
          /* font-weight: 600; */
          line-height: 2.5rem;
          margin-right: 1.3rem;
          color: #222A30;
          font-family: 'Source Sans Pro';
        }

        svg {
          padding-right: 1rem;
          vertical-align: middle;
        }

        svg.icon-star {
          padding-right: 0;
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }

  .panel_dividing_line {
    border-bottom: 0.2rem dashed #e7e9ea;
  }

  .div_guest_order_info {
    padding: 0.9rem 1.3rem;
  }

  .div_room_title {
    line-height: 2.5rem;
    font-size: 1.8rem;
    margin-bottom: 1.3rem;
    font-weight: 600;
  }

  .div_room_item {
    display: flex;
    justify-content: space-between;

    .o_title {
      font-size: 1.4rem;
      color: $text-fill-color;
    }

    .o_info {
      font-size: 1.4rem;
    }

    .avg_title, .avg_info {
      font-size: 1.8rem;
      line-height: 2.5rem;
    }

    .total_title, .total_info {
      font-size: 3rem;
      line-height: 4.2rem;
      font-weight: 600;
    }
  }

  .room_item_margin:not(:last-child) {
    margin-bottom: 1rem;
  }

  .div_room_button {
    text-align: center;
  }

  .icon-circlecheck {
    vertical-align: -0.4em;
  }

  .price_link {
    text-align: right;
    padding-bottom: 1.3rem;
    font-size: 1.8rem;
    line-height: 2.5rem;
  }
  .price-dialog {
    min-width: 20%;
    font-weight: 600;
    ::v-deep .el-dialog {
      width: 90%;

      .el-dialog__title {
        font-size: 1.8rem;
      }

      .el-dialog__headerbtn {
        font-size: 2.5rem;
      }
    }
  }

  ::v-deep .price-dialog .el-dialog__body {
    padding: 1rem 2rem;
  }

  ::v-deep .el-message-box__status {
    color: $btn-bg-color-hover;
  }

  ::v-deep .el-dialog__footer {
    padding-top: 0;
    padding-bottom: 0;
  }

  ::v-deep .el-dialog--center .el-dialog__body {
    padding-top: 1.3rem;
    padding-bottom: 1.3rem;
  }

  ::v-deep .el-table__fixed-right::before, ::v-deep .el-table__fixed::before {
    z-index: inherit;
  }

  ::v-deep .el-form--label-top .el-form-item__label {
    padding: 0px;
  }
  .add-guest-div {
    display: block;
    float: right;
    margin-right: 6%;
    margin-top: -5rem;
  }
  .add-guest-btn {
    padding: 8px 13px;
    background-color: $btn-bg-color;
    color: $btn-font-color;
    pointer-events: auto;
  }
}

/* 电脑屏幕 */
@media screen and (min-width: 961px) {
 
  .side_sticky {
    position: sticky;
    top: 0;
  }

  .panel_bg {
    background-color: #FFF;
  }

  .hotel_info {
    display: flex;
  }

  .div_hotel_info_img {
    width: 70%;
  }

  .hotel_info_img {
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;
  }

  .hotel_info_text {
    padding: 1.3rem;
    width: 100%;

    ul {
      display: flex;
      flex-direction: column;
      font-size: 1.4rem;

      li {
        line-height: 2rem;
        padding-bottom: 1.2rem;
        display: inline-block;

        h1 {
          display: inline;
          font-size: 1.8rem;
          /* font-weight: 600; */
          line-height: 2.5rem;
          margin-right: 1.3rem;
          color: #222A30;
          font-family: 'Source Sans Pro';
        }

        svg {
          padding-right: 1rem;
          vertical-align: middle;
        }

        svg.icon-star {
          padding-right: 0;
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }

  .panel_dividing_line {
    border-bottom: 0.2rem dashed #e7e9ea;
  }

  .div_guest_order_info {
    padding: 0.9rem 1.3rem;
  }

  .div_room_title {
    line-height: 2.5rem;
    font-size: 1.8rem;
    margin-bottom: 1.3rem;
    font-weight: 600;
  }

  .div_room_item {
    display: flex;
    justify-content: space-between;

    .o_title {
      font-size: 1.4rem;
      color: $text-fill-color;
    }

    .o_info {
      font-size: 1.4rem;
    }

    .avg_title, .avg_info {
      font-size: 1.8rem;
      line-height: 2.5rem;
    }

    .total_title, .total_info {
      font-size: 3rem;
      line-height: 4.2rem;
      font-weight: 600;
    }
  }

  .room_item_margin:not(:last-child) {
    margin-bottom: 1rem;
  }

  .div_room_button {
    text-align: center;
  }

  .icon-circlecheck {
    vertical-align: -0.4em;
  }

  .price_link {
    text-align: right;
    padding-bottom: 1.3rem;
    font-size: 1.8rem;
    line-height: 2.5rem;
  }
  .price-dialog {
    font-weight: 600;
  }
  ::v-deep .price-dialog .el-dialog__body {
    padding: 1rem 2rem;
  }

  ::v-deep .el-message-box__status {
    color: $btn-bg-color-hover;
  }

  ::v-deep .el-dialog__footer {
    padding-top: 0;
    padding-bottom: 0;
  }

  ::v-deep .el-dialog--center .el-dialog__body {
    padding-top: .3rem!important;
    padding-bottom: .3rem!important;
  }

  ::v-deep .el-table__fixed-right::before, ::v-deep .el-table__fixed::before {
    z-index: inherit;
  }

  ::v-deep .el-form--label-top .el-form-item__label {
    padding: 0px;
  }
  .input_pay {
    width: 15%;
  }
  .add-guest-div {
    display: block;
    float: right;
    margin-right: 6%;
    margin-top: -5rem;
  }
  .add-guest-btn {
    padding: 8px 13px;
    background-color: $btn-bg-color;
    color: $btn-font-color;
    pointer-events: auto;
  }
}

::v-deep .el-rate__icon {
  font-size: 2rem;
  margin-right: 0;
}

::v-deep .el-textarea{
  width:28rem;
}
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
  width:181px;
}
.title-divider {
  margin-bottom: 1rem;
  margin-top: -1rem;
  height: 2px;
  background-color: $btn-bg-color;
}
.form_item{
  margin-bottom: 22px;
}

.cancel-dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
}

.cancel-dialog-button {
  min-width: 9rem;
  height: 3.6rem;
  padding: 0.6rem 1.8rem;
  font-size: 1.5rem;
  line-height: 1.4;
}
</style>
